main.scroll = (function () {
    var enableSmoothScroll = false;
    var enableReveal = true;
    var offset = 10; // Offset from bottom in %
    var threshold = window.innerHeight * ( 1 - (offset / 100));
    var items = document.getElementsByClassName('js-reveal');

    var init = function () {
        if (enableSmoothScroll) {
            var scroll = new SmoothScroll('a[href*="#"]');
        }
    };

    var handleVisiblity = function () {
        if (!enableReveal) { return; }

        for (var i = 0; i < items.length; i++) {
            var item = items[i];
            if (main.utils.hasClass(item, 'is-revealed')) { continue; }

            if (item.getBoundingClientRect().top <= threshold) {
                main.utils.addClass(item, 'is-revealed');
            } else {
            }
        }
    };

    return {
        init: init,
        handleVisiblity: handleVisiblity
    };
})();
